import React from "react"
import {Result, Table} from "antd"
import {useClubTableBookSettingContext} from "../store/useClubTableBookSettingContext"

const BookSettingRelation = () => {

    const {reservationSetting, isShowReserve} = useClubTableBookSettingContext()

    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '套餐名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '价格(元)',
            dataIndex: 'amount',
            key: 'amount',
            render: (text) => {
                return (text / 100).toFixed(2)
            }
        },
        {
            title: '时长（分钟）',
            dataIndex: 'duration',
            key: 'duration',
            render: (text) => {
                return (text / 60).toFixed(0)
            }
        }
    ]
    return (
        <div>
            {isShowReserve ? <Table columns={columns}
                                    dataSource={reservationSetting.prepaids}
                                    rowKey={record => record.id}
            /> : <Result status={"info"} subTitle={"暂未开启预定，开启可以查看"}></Result>}
        </div>
    )
}

export default BookSettingRelation


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/component/BookSettingRelation.js